import type { ReactElement } from 'react';
import { ChevronRight } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import {
  DRILL_DOWN_CHIP_BOX_CLASS,
  DRILL_DOWN_CHIP_CLASS,
  DRILL_DOWN_CHIP_ICON_CLASS,
} from '@/styles/drillDownChip';
import { formatNumber } from '@/utils/number';

const DRILL_DOWN_COUNT_CLASS = cn(DRILL_DOWN_CHIP_CLASS, 'tabular-nums');
const ZERO_COUNT_CLASS = cn(DRILL_DOWN_CHIP_BOX_CLASS, 'tabular-nums text-muted-foreground');

interface DrillDownCountProps {
  count: number;
  hint: string;
  ariaLabel?: string | undefined;
  render: ReactElement;
}

interface DrillDownCountButtonProps extends Omit<DrillDownCountProps, 'render'> {
  onOpen: () => void;
}

export function DrillDownCount({ count, hint, ariaLabel = hint, render }: DrillDownCountProps) {
  if (count === 0) {
    return <span className={ZERO_COUNT_CLASS}>0</span>;
  }

  return (
    <Tooltip>
      <TooltipTrigger
        render={render}
        aria-label={ariaLabel}
        className={DRILL_DOWN_COUNT_CLASS}
        onClick={(event) => event.stopPropagation()}
      >
        {formatNumber(count)}
        <ChevronRight className={DRILL_DOWN_CHIP_ICON_CLASS} aria-hidden />
      </TooltipTrigger>
      <TooltipContent>{hint}</TooltipContent>
    </Tooltip>
  );
}

export function DrillDownCountButton({ onOpen, ...countProps }: DrillDownCountButtonProps) {
  return <DrillDownCount {...countProps} render={<button type="button" onClick={onOpen} />} />;
}
